import { Button } from '@yellowcard/components-library-vue3';
import { formatDate } from '@/utils/helpers';
import useTransactionsStore from '@/store/modules/transactions';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { TransactTypes } from '@/types/transact';
export default {
    name: 'SellDepositNotFound',
    components: {
        Button,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { payment, currentStep } = storeToRefs(transactionStore);
        const authStore = useAuthStore();
        const { user } = storeToRefs(authStore);
        const goToMyAccount = () => {
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        return {
            formatDate,
            payment,
            user,
            goToMyAccount,
        };
    },
};
